import { render } from "./OrderSparePartInfosModal.vue?vue&type=template&id=6636d0d8&scoped=true&ts=true&lang=pug"
import script from "./OrderSparePartInfosModal.vue?vue&type=script&lang=ts"
export * from "./OrderSparePartInfosModal.vue?vue&type=script&lang=ts"

import "./OrderSparePartInfosModal.vue?vue&type=style&index=0&id=6636d0d8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6636d0d8"]])

export default __exports__